var _circle, _path, _path2, _path3, _path4, _path5, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataInjection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2485 64.903L17.0226 34.6272C16.9422 34.0509 17.0779 33.4648 17.4024 32.9867C17.7269 32.5086 18.2161 32.1739 18.7717 32.05L36.0866 28.1103C36.7326 27.9632 37.4022 27.9632 38.0482 28.1103L55.3631 32.0523C56.5156 32.3137 57.2794 33.4311 57.1122 34.6295L52.8863 64.903C52.7281 66.0482 51.7564 73 37.0674 73C22.3784 73 21.4067 66.0482 21.2485 64.903Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0715 57.3922H33.4686V52.072H28.1484V44.4691H33.4686V39.1489H41.0715V44.4691H46.3917V52.072H41.0715V57.3922Z",
    fill: "#6484F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1257 25.2714C82.0709 24.5296 80.805 24.1057 79.4864 24.0527H79.2754C77.1129 24.0527 74.8449 25.1125 73.1571 27.5499L68.4102 34.2792C70.9946 36.8226 74.7922 39.9488 79.6974 42.0682L84.3389 35.4979C87.187 31.4709 85.9212 27.2319 83.1257 25.2714Z",
    fill: "#6484F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7952 28.6452L74.7952 28.6452L74.8018 28.6357C76.1424 26.6997 77.8145 26 79.2758 26H79.4433C80.3736 26.0442 81.2525 26.3461 81.9757 26.8547L81.9777 26.8561C83.8599 28.1761 84.9195 31.1612 82.7064 34.2903L82.7064 34.2903L82.7015 34.2971L72.1527 49.3454L72.1527 49.3454L72.1475 49.3529C69.9776 52.4788 66.8617 52.4966 64.9907 51.149L64.9805 51.1416L64.9702 51.1344C63.088 49.8144 62.0285 46.8293 64.2416 43.7003L64.2416 43.7003L64.2464 43.6934L74.7952 28.6452Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2164 61.274C78.3178 58.0244 73.6208 58.0277 71.7267 61.2798L59.3025 82.6125C57.3945 85.8887 59.7578 90 63.5491 90H88.4372C92.2315 90 94.5944 85.8827 92.6803 82.6066L80.2164 61.274Z",
    fill: "#6484F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.5859,
    y: 67,
    width: 4,
    height: 11.9998,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5859,
    y: 81.4001,
    width: 4,
    height: 3.59994,
    rx: 1,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataInjection);
export default __webpack_public_path__ + "static/media/data-injection.05d69ee3a8f4d6b571bedbe7304902bb.svg";
export { ForwardRef as ReactComponent };